<template>
    <div>
        <div class="container" :style="{minHeight:minHeight + 'px'}">
            <Head></Head>
            <!-- <img style="width:100%;" src="./../assets/image/back/home_back.png" alt="">
            <div class="joinOur"><router-link tag="div" :to="{ name: 'register'}" class="top-right-right">加入我们</router-link></div> -->
            <div class="content1">
                <!-- <div class="joinOur"><router-link tag="div" :to="{ name: 'register'}" class="top-right-right">加入我们</router-link></div> -->
                <div class="top">
                    <div style="margin:0 auto;float:none;">
                        <template>
                            <el-carousel class="hero-carousel" indicator-position="inside" :height="heroHeight" :interval="6000">
                                <el-carousel-item v-for="(item,index) in images" :key="item.uri || index">
                                    <img :src="item.uri" class="hero-image" alt="北京企业技术中心创新服务联盟"
                                         :loading="index === 0 ? 'eager' : 'lazy'" :fetchpriority="index === 0 ? 'high' : 'auto'"
                                         decoding="async" @error="handleHeroError">
                                </el-carousel-item>
                            </el-carousel>
                        </template>
                    </div>
                </div>
            </div>
            <div class="content" style="width:1200px;overflow:hidden;cursor:default;">
                <div>
                    <div style="float:right;line-height:100px;cursor:pointer;">
                        <router-link style="color:#555;font-weight:bold" tag="p" class="more" :to="{name:'articlelist',params:{index:1}}">更多 </router-link>
                    </div>
                    <span style="line-height:100px;font-size:20px;font-weight:bolder;">联盟动态</span>
                    <!-- <span style="font-size:14px;">/ DYNAMIC ALLIANCE</span> -->
                    <span style="font-size:14px;">/ Info</span>
                </div>
                <div>
                    <div class="article-card" v-for="(item,index) in tableData0.list" :key="index"  style="width:360px;height:250px;float:left;margin-bottom:30px;border:2px solid #f3eded;margin-right:36px;">
                        <div style="width:360px;height:200px;"><img :src="articlePreview(item)" :alt="item.title" loading="lazy" decoding="async" @error="handleContentImageError" style="width:360px;height:200px"></div>
                        <div style="text-align:left;line-height:24px;padding:0 10px;font-size:14px;color:#9e9e9e;">
                            <router-link style="text-decoration: none;color:#555;font-weight:bold;display: inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:340px;text-align: center;" tag="a" :to="{name:'article',params:{id:item.id}}">{{item.title}}
                            </router-link>
                            <!-- <p style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{item.context}}</p>
                            <p class="type" v-if="item.classify">[{{item.classify}}]</p>
                            <p class="date">{{timestampToTime(item.uploadTime)}}</p> -->
                        </div>
                    </div>
                    <!-- <div style="width:300px;height:300px;float:left;margin-right:30px;margin-bottom:30px;box-shadow: 5px 5px rgb(243 237 237);">
                        <div style="width:300px;height:200px;"></div>
                        <div style="text-align:left;line-height:24px;padding:0 10px;font-size:14px;color:#9e9e9e;">
                            <p style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">内容</p>
                            <p class="type">123</p>
                            <p class="date">123</p>
                        </div>
                    </div> -->
                </div>
            </div>
            <div @click="toSelfCheck" style="cursor: pointer;height:240px;border-radius: 30px;box-shadow: 2px 0px 8px 8px #e4e4e4;margin: 0 10px;background: #F3F4F6;width:1200px;margin:0 auto;">
                <!-- <div style="width:1200px;margin:0 auto;"> -->
                    <!-- <div style="height:300px;margin-top:50px;float:left;width:300px;margin-left:191px;">
                        <div class="center-right" style="position:relative;">
                            <div class="box" style="width: 105px;background:#35A3E7;height: 50px;line-height: 50px;font-size: 14px;color: #fff;position: absolute;bottom: 26px;right: -50px;"><router-link style="text-decoration: none;color:#fff;" to="/selfassessmententer">企业自评</router-link></div>
                            <router-link tag="a" to="/selfassessmententer"><img style="width:200px;height:200px;" :src="evaluateImages"
                                                                                alt=""></router-link>

                        </div>
                    </div> -->
                    <!-- <div style="position:relative;height:300px;margin-top:50px;float:left;width:300px;margin-left:191px;">
                        <div class="bottom-right">
                            <div class="box"  style="width: 105px;background:#D12C2A;height: 50px;line-height: 50px;font-size: 14px;color: #fff;position: absolute;bottom: 26px;right: -50px;"><router-link style="text-decoration: none;color:#fff;" tag="a" to="/industrymap">产业地图</router-link></div>
                            <router-link tag="a" to="/industrymap"><img style="width:300px;height:300px;" :src="industryImages" alt=""></router-link>
                        </div>
                    </div> -->
                <!-- </div> -->
                <div style="width:1180px;margin:0 auto;">
                    <div style="float:left;width: 300px;margin-top:20px">
                        <router-link tag="a" to="/selfassessmententer"><img style="width:200px;height:200px;border-radius: 50%;" :src="evaluateImages"
                            alt=""></router-link>
                    </div>
                    <div style="float:left;width:840px;font-size: 16px;letter-spacing:2px;text-align:left;line-height:24px;">
                        <div style="margin-top:40px;font-weight:bold;">企业自评</div>
                        来源：北京企业技术中心创新服务联盟发布的《企业技术中心建设评价规范》(TBETC BETC001—2021）附录B 北京市企业技术中心评价表。
                        功能：企业满足基本要求且评价得分在60分及以上为合格。本表适用于对北京市企业技术中心申请创建和运行评价。
                    </div>
                </div>
            </div>
            <div class="content">
                <div class="bottom" style="height:356px;">
                    <div class="bottom-left" style="margin:0 130px;">
                        <!-- <div style="cursor:default;" class="box"><p>最新通知<span style="font-size:14px;font-weight:0;">/ THE LATEST NOTICE</span></p> -->
                            <div style="cursor:default;" class="box"><p>最新通知<span style="font-size:14px;font-weight:0;">/ News</span></p>
                            <router-link tag="p" class="more" :to="{name:'articlelist',params:{index:2}}">更多
                            </router-link>
                        </div>
                        <ul>
                            <li v-for="(item,index) in tableData1.list" :key="index">
                                <div class="publishdate">
                                    <h1>{{timestampToTime(item.uploadTime).substring(0,4)}}</h1>
                                    <p>{{timestampToTime(item.uploadTime).substring(5,10)}}</p>
                                </div>
                                <div class="publishtitle">
                                    <router-link tag="a" :to="{name:'article',params:{id:item.id}}">{{item.title.length>30?item.title.substring(0,30)+"...":item.title}}
                                    </router-link>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="bottom-center">
                        <!-- <div style="cursor:default;" class="box"><p>一周政策<span style="font-size:14px;font-weight:0;">/ A WEEK POLICY</span></p> -->
                        <div style="cursor:default;" class="box"><p>政策法规<span style="font-size:14px;font-weight:0;">/ Policy</span></p>
                            <router-link tag="p" class="more" :to="{name:'articlelist',params:{index:3}}">更多
                            </router-link>
                        </div>
                        <ul>
                            <li v-for="(item,index) in tableData2.list" :key="index">
                                <router-link style="font-size:16px;" tag="a" :to="{name:'article',params:{id:item.id}}">{{item.title}}
                                </router-link>
                            </li>
                        </ul>

                    </div>
                </div>
            </div>
            <!-- <div class="content">
                <div class="top">
                    <div class="top-left">
                        <template>
                            <el-carousel indicator-position="inside" height="430px">
                                <el-carousel-item v-for="(item,index) in images" :key="index">
                                    <img :src="item.uri" alt="" style="width:820px;height:430px">
                                </el-carousel-item>
                            </el-carousel>
                        </template>

                    </div>
                    <div class="top-right">
                        <div class="top-right-top" :style="{backgroundImage:'url(' + introduceImages + ')',backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize: 'contain'}">
                            <div class="top-right-top-float"></div>
                        </div>
                        <router-link tag="div" :to="{name:'articlelist',params:{index:2}}" class="top-right-left">服务
                        </router-link>
                        <router-link tag="div" :to="{ name: 'register'}" class="top-right-right">加入</router-link>
                    </div>
                </div>
                <div class="center">
                    <div class="center-left">
                        <div class="box">
                            <p><span></span>联盟动态</p>
                            <router-link tag="p" class="more" :to="{name:'articlelist',params:{index:1}}">更多
                            </router-link>
                        </div>
                        <ul>
                            <li v-for="(item,index) in tableData0.list" :key="index">
                                <div class="news-image">
                                    <img :src="item.preview.uri" alt="" style="width:205px;height:131px">
                                </div>
                                <div class="news-content">
                                    <router-link tag="a" :to="{name:'article',params:{id:item.id}}">{{item.title}}
                                    </router-link>
                                    <p>{{item.context}}</p>
                                    <p class="type" v-if="item.classify">[{{item.classify}}]</p>
                                    <p class="date">{{timestampToTime(item.uploadTime)}}</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="center-right">
                        <div class="box"><p><span></span>企业自评</p></div>
                        <router-link tag="a" to="/selfassessmententer"><img :src="evaluateImages"
                                                                            alt=""></router-link>

                    </div>
                </div>
                <div class="bottom">
                    <div class="bottom-left">
                        <div class="box"><p><span></span>最新通知</p>
                            <router-link tag="p" class="more" :to="{name:'articlelist',params:{index:2}}">更多
                            </router-link>
                        </div>
                        <ul>
                            <li v-for="(item,index) in tableData1.list" :key="index">
                                <div class="publishdate">
                                    <h1>{{timestampToTime(item.uploadTime).substring(0,4)}}</h1>
                                    <p>{{timestampToTime(item.uploadTime).substring(5,10)}}</p>
                                </div>
                                <div class="publishtitle">
                                    <router-link tag="a" :to="{name:'article',params:{id:item.id}}">{{item.title}}
                                    </router-link>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="bottom-center">
                        <div class="box"><p><span></span>一周政策</p>
                            <router-link tag="p" class="more" :to="{name:'articlelist',params:{index:3}}">更多
                            </router-link>
                        </div>
                        <ul>
                            <li v-for="(item,index) in tableData2.list" :key="index">
                                <router-link tag="a" :to="{name:'article',params:{id:item.id}}">{{item.title}}
                                </router-link>
                            </li>
                        </ul>

                    </div>
                    <div class="bottom-right">
                        <div class="box"><p><span></span>产业地图</p></div>
                        <router-link tag="a" to="/industrymap"><img :src="industryImages" alt=""></router-link>
                    </div>
                </div>
            </div> -->

        </div>
        <div class="content">
            <div class="bottom">
                <div class="bottom-left-members-show">
                    <!-- <div style="cursor:default;" class="box"><p style="float:none;">会员介绍<span style="font-weight:0;font-size:14px;">/ MEMBER INTRODUCTION</span></p> -->
                        <div style="cursor:default;" class="box"><p style="float:none;">会员介绍<span style="font-weight:0;font-size:14px;">/ Membership</span></p>
                        <router-link tag="p" class="more" :to="{name:'huiyuanCenter',params:{index:4}}">更多</router-link>
                    </div>
                    <ul v-if="showData.length" class="member-grid">
                        <li v-for="(item,index) in showData" :key="index">
                            <!-- <router-link tag="a" :to="{name:'article',params:{id:item.preview.id}}">
                                <div class="show-image"><img v-bind:src="item.preview.uri"
                                                             style="width:205px;height:90px;margin: 10px;border:5px solid #f5f7fa">
                                </div>
                            </router-link> -->
                            <!-- 修改会员展示 -->
                            <div class="member-card">
                                <router-link tag="a" :to="{name:'article',params:{id:item.articleId}}">
                                    <div class="show-image"><img class="member-logo" :src="item.uri || contentImageFallback"
                                                                @error="handleContentImageError">
                                    </div>
                                </router-link>
                                <div class="member-name" :title="item.name">{{item.name&&item.name.length>8?item.name.slice(0,8)+'...':item.name}}</div>
                            </div>
                        </li>
                    </ul>
                    <div v-else-if="memberLoadFailed" class="member-empty">会员介绍加载失败，请刷新页面重试</div>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="bottom" style="height:200px;width:1200px">
                <div class="bottom-left-friend-link">
                    <div style="cursor:default;" class="box"><p style="float:none;">友情链接<span style="font-weight:0;font-size:14px;">/ Links</span></p></div>
                    <!-- <div style="cursor:default;" class="box"><p style="float:none;">友情链接<span style="font-weight:0;font-size:14px;">/ links</span></p></div> -->
                    <vue-seamless-scroll :data="friendLinkData" :class-option="optionLeft" class="seamless-warp">
                        <ul>
                            <li v-for="(item,index) in friendLinkData" :key="index">
                                <div class="show-image"><img v-bind:src="item.preview.uri"
                                                             @click="handleOpenUrl(item.linkUrl)"
                                                             style="width:205px;height:90px;margin: 10px;border:5px solid #f5f7fa">
                                </div>
                            </li>
                        </ul>
                    </vue-seamless-scroll>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    // @ is an alias to /src
    //import HelloWorld from "@/components/HelloWorld.vue";
    import Head from "@/components/Head.vue";
    import Footer from "@/components/Footer.vue";
    import {articleList} from "@/api/article";
    import {getImages, getIntroduceImages, getEvaluateImages, getIndustryImages} from "@/api/image";
    import {getMembersShowImages} from "@/api/membersshow";
    import {getFriendLinkImages} from "@/api/friendlink";
    import heroFallback from "@/assets/image/home-hero-fallback.jpg";
    import contentImageFallback from "@/assets/image/logo.png";

    export default {
        data() {
            return {
                minHeight: 10,
                heroHeight: "560px",
                tableData0: {list: []},
                tableData1: {list: []},
                tableData2: {list: []},
                showData: [],
                memberLoadFailed: false,
                friendLinkData: [],
                images: [{uri: heroFallback, fallback: true}],
                heroFallback,
                contentImageFallback,
                introduceImages: "",
                evaluateImages: "",
                industryImages: "",
            };
        },
        mounted() {
            this.updateLayout();
            window.addEventListener("resize", this.updateLayout, {passive: true});
            [
                this.getArticleList0(),
                this.getArticleList1(),
                this.getArticleList2(),
                this.handleImages(),
                this.getIntroduceImages(),
                this.getEvaluateImages(),
                this.getIndustryImages(),
                this.getMembersShowImages(),
                this.getFriendLinkImages()
            ].forEach(task => Promise.resolve(task).catch(() => null));
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.updateLayout);
        },
        methods: {
            updateLayout() {
                const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
                this.minHeight = Math.max(10, document.documentElement.clientHeight - 240);
                const height = Math.max(300, Math.min(620, Math.round(viewportWidth * 0.34)));
                this.heroHeight = `${height}px`;
            },
            handleOpenUrl(url) {
                window.open(url);
            },
            articlePreview(item) {
                return item && item.preview && item.preview.uri ? item.preview.uri : this.contentImageFallback;
            },
            handleContentImageError(event) {
                if (event.target.src !== this.contentImageFallback) event.target.src = this.contentImageFallback;
                event.target.classList.add("content-image-fallback");
            },
            handleHeroError(event) {
                if (event.target.src !== this.heroFallback) event.target.src = this.heroFallback;
            },
            getMembersShowImages() {
                this.memberLoadFailed = false;
                return getMembersShowImages(1, 1, 6).then(res => {
                    const payload = res && res.data ? res.data : res;
                    this.showData = payload && Array.isArray(payload.list) ? payload.list : [];
                    this.memberLoadFailed = !this.showData.length;
                }).catch(() => {
                    this.showData = [];
                    this.memberLoadFailed = true;
                });
            },
            getFriendLinkImages() {
                return getFriendLinkImages().then(res => {
                    this.friendLinkData = res;
                })
            },
            handleImages() {
                return getImages().then(res => {
                    const candidates = Array.isArray(res) ? res.filter(item => item && item.uri) : [];
                    if (!candidates.length) return;
                    Promise.all(candidates.map(item => this.preloadImage(item.uri, 2500).then(ok => ok ? item : null)))
                        .then(items => {
                            const available = items.filter(Boolean);
                            if (available.length) this.images = available;
                        });
                }).catch(() => null);
            },
            preloadImage(uri, timeout) {
                return new Promise(resolve => {
                    const image = new Image();
                    let finished = false;
                    const complete = value => {
                        if (finished) return;
                        finished = true;
                        clearTimeout(timer);
                        image.onload = null;
                        image.onerror = null;
                        resolve(value);
                    };
                    const timer = window.setTimeout(() => complete(false), timeout);
                    image.onload = () => complete(true);
                    image.onerror = () => complete(false);
                    image.src = uri;
                });
            },
            getIntroduceImages() {
                return getIntroduceImages().then(res => {
                    this.introduceImages = res[0].uri;
                })
            },
            getEvaluateImages() {
                return getEvaluateImages().then(res => {
                    this.evaluateImages = res[0].uri;
                })
            },
            getIndustryImages() {
                return getIndustryImages().then(res => {
                    this.industryImages = res[0].uri;
                })
            },
            //联盟动态
            getArticleList0() {
                return articleList(1, 3, 0).then(res => {
                    this.tableData0 = res;

                })
            },
            //最新通知
            getArticleList1() {
                return articleList(1, 5, 1).then(res => {
                    this.tableData1 = res;
                })
            },
            //一周政策
            getArticleList2() {
                return articleList(1, 5, 2).then(res => {
                    this.tableData2 = res;
                })
            },
            timestampToTime(timestamp) {
                const date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
                const Y = date.getFullYear() + '-';
                const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
                const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
                const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                return Y + M + D + h + m + s;//时分秒可以根据自己的需求加上
            },
            // 增加企业自评跳转
            toSelfCheck(){
                this.$router.push({path:'/selfassessmententer'});
            }
        },
        components: {
            Head,
            Footer
        }, 
        computed: {
            optionLeft() {
                return {
                    direction: 2,
                    limitMoveNum: 2
                }
            }
        }
    };
</script>
<style lang="scss" scoped>
    .seamless-warp {
        overflow: hidden;
        height: 122px;
    }

    .content {
        width: 1200px;
        margin: 0 auto;

        .top {
            height: 430px;

            .top-left {
                width: 820px;
                height: 430px;
                float: left;

                .el-carousel {
                    position: inherit;
                }
            }

            .top-right {
                width: 380px;
                height: 430px;
                float: right;
                position: relative;

                p {
                    font-size: 14px;
                    color: #666666;
                    padding: 10px;
                    text-align: left;
                }

                a {
                    text-decoration: none;
                    color: #999999;
                    text-align: right;
                    font-size: 14px;
                    display: block;
                    padding: 0 10px 5px;
                }

                .top-right-top {
                    //height: 30px;
                    //background: url(../assets/image/introduction.png);
                    background-repeat: no-repeat;
                    background-size: cover;
                    margin: 0, auto;
                    height: 330px;
                    width: 380px;
                }

                .top-right-top-float {
                    position: absolute;
                    bottom: 110px;
                    left: 0px;
                    //color: #0099E2;
                    p {
                        color: #ece8e8;
                        padding: 0px 10px 0px 10px;
                    }

                    a {
                        color: #ece8e8;
                        padding: 0px 20px 0px 0px;
                    }
                }

                .top-right-left {
                    width: 190px;
                    height: 100px;
                    float: left;
                    color: #ffffff;
                    line-height: 100px;
                    // background-color: #0099E2;
                    bottom: 0;
                    left: 0;
                    position: absolute;
                    cursor: pointer;
                }

                .top-right-right {
                    width: 190px;
                    height: 100px;
                    float: right;
                    color: #ffffff;
                    line-height: 100px;
                    background-color: #ffbf4f;
                    bottom: 0;
                    right: 0;
                    position: absolute;
                    cursor: pointer;
                }
            }
        }

        .center {
            height: 500px;
            //width: 1400px;
            margin: 20px 0 0 0;

            .center-left {
                width: 820px;
                display: inline-block;
                margin-left: -20px;

                .box {
                    position: relative;
                    height: 46px;
                    // border-bottom: 1px solid #0099E2;

                    p {
                        display: inline-block;
                        text-align: center;
                        float: left;
                        height: 46px;
                        // width: 100px;
                        line-height: 46px;
                        // color: #ffffff;
                        // background-color: #0088d3;
                        color: #303133;
                        font-weight: bold;
                        // span {
                        //     display: inline-block;
                        //     width:14px;
                        //     height:14px;
                        //     // background: #0099E2;
                        //     position:relative;
                        //     top:1px;
                        //     margin-right: 10px;
                        // }
                    }

                    p.more {
                        float: right;
                        cursor: pointer;
                        color: #555555;
                        display: inline-block;
                        background-color: #fff;
                    }
                }

                li {
                    height: 131px;
                    padding: 10px 0px 0px 0px;
                    border-bottom: 1px solid #eeeeee;

                    .news-image {
                        width: 205px;
                        height: 131px;
                        float: left;
                    }

                    .show-image {
                        width: 205px;
                        height: 90px;
                        float: left;
                        margin: 10px;
                    }

                    .news-content {
                        height: 131px;
                        width: 580px;
                        float: right;
                        position: relative;

                        a {
                            padding: 10px;
                            display: block;
                            text-align: left;
                            text-decoration: none;
                            color: #555555;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }

                        p {
                            padding: 5px;
                            text-align: left;
                            font-size: 14px;
                            color: #999999;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }

                        p.type {
                            position: absolute;
                            bottom: 0;
                        }

                        p.date {
                            position: absolute;
                            right: 0;
                            bottom: 0;
                        }
                    }
                }
            }

            .center-right {
                width: 360px;
                height: 500px;
                float: right;
                display: inline-block;

                .box {
                    // border-bottom: 1px solid #0099E2;

                    p {
                        text-align: center;
                        height: 46px;
                        // width: 100px;
                        line-height: 46px;
                        // color: #ffffff;
                        // background-color: #0088d3;
                        color: #303133;
                        font-weight: bold;
                        // span {
                        //     display: inline-block;
                        //     width:14px;
                        //     height:14px;
                        //     // background: #0099E2;
                        //     position:relative;
                        //     top:1px;
                        //     margin-right: 10px;
                        // }
                    }
                }

                img {
                    width: 360px;
                    height: 440px;
                    margin: 10px 0 0;
                }
            }
        }

        .bottom {
            /* height: 396px; */
            padding: 20px 0 0;
            padding: 20px 0px 0 0px;
            
            border: 1px solid transparent;
            overflow: hidden;;
            .box {
                position: relative;
                height: 46px;
                // border-bottom: 1px solid #0099E2;

                p {
                    display: inline-block;
                    text-align: center;
                    float: left;
                    height: 46px;
                    // width: 100px;
                    line-height: 46px;
                    // color: #ffffff;
                    // background-color: #0088d3;
                    color: #303133;
                    font-weight: bold;
                    // span {
                    //     display: inline-block;
                    //     width:14px;
                    //     height:14px;
                    //     // background: #0099E2;
                    //     position:relative;
                    //     top:1px;
                    //     margin-right: 10px;
                    // }
                }

                p.more {
                    float: right;
                    cursor: pointer;
                    color: #555555;
                    display: inline-block;
                    background-color: #fff;
                }
            }

            .bottom-left {
                float: left;
                width: 400px;
                display: inline-block;

                ul {
                    height: 333px;

                    li {
                        border-bottom: 1px solid #eeeeee;

                        .publishdate {
                            width: 70px;
                            margin: 25px 0 20px;
                            display: inline-block;
                            border-right: 2px solid #eeeeee;

                            h1 {
                                font-size: 20px;
                                color: #555555;
                            }

                            p {
                                font-size: 14px;
                                color: #999999;
                            }
                        }

                        .publishtitle {
                            line-height: 20px;
                            text-align: left;
                            width: 304px;
                            margin: 0 0 20px 10px;
                            color: #555555;
                            display: inline-block;

                            a {
                                text-decoration: none;
                                color: #555555;
                                position: relative;
                                /* top:-8px; */
                            }
                        }
                    }
                }
            }

            .bottom-left-members-show {
                float: left;
                width: 1200px;
                display: inline-block;

                ul {
                    /* height: 333px; */
                    overflow: visible;
                    border-bottom:1px solid transparent;
                    &.member-grid {
                        display: grid;
                        grid-template-columns: repeat(6, minmax(0, 1fr));
                        gap: 12px;
                        padding: 8px 0 20px;
                    }
                    li {
                        text-align: left;
                        /* display: inline-block;
                        border-bottom: 1px solid #eeeeee; */
                        float:none;
                        min-width: 0;
                        .publishdate {
                            width: 70px;
                            margin: 25px 0 20px;
                            display: inline-block;
                            border-right: 2px solid #eeeeee;

                            h1 {
                                font-size: 20px;
                                color: #555555;
                            }

                            p {
                                font-size: 14px;
                                color: #999999;
                            }
                        }

                        .publishtitle {
                            line-height: 20px;
                            text-align: left;
                            width: 304px;
                            margin: 0 0 20px 10px;
                            color: #555555;
                            display: inline-block;

                            a {
                                text-decoration: none;
                                color: #555555;
                            }
                        }
                        /* .show-image img {
                            width:170px;
                            height:170px;
                            margin: 10px 10px 0;
                            border:5px solid #f5f7fa;
                            border-radius: 50%;
                        } */
                    }
                }

                .member-card {
                    height: 205px;
                    padding: 8px;
                    border: 1px solid #edf2f7;
                    border-radius: 8px;
                    background: #fff;
                    box-sizing: border-box;
                }

                .member-logo {
                    display: block;
                    width: 150px;
                    height: 150px;
                    margin: 0 auto 8px;
                    border-radius: 50%;
                    object-fit: cover;
                    background: #f5f7fa;
                }

                .member-name {
                    height: 28px;
                    overflow: hidden;
                    color: #26384a;
                    font-size: 16px;
                    line-height: 28px;
                    text-align: center;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }

                .member-empty {
                    padding: 36px 0;
                    color: #8a98a8;
                    text-align: center;
                }
            }

            .bottom-left-friend-link {
                float: left;
                width: 1200px;
                display: inline-block;

                ul {
                    height: 120px;
                    width: 3500px;

                    li {
                        text-align: left;
                        display: inline-block;
                        border-bottom: 1px solid #eeeeee;

                        .publishdate {
                            width: 70px;
                            margin: 25px 0 20px;
                            display: inline-block;
                            border-right: 2px solid #eeeeee;

                            h1 {
                                font-size: 20px;
                                color: #555555;
                            }

                            p {
                                font-size: 14px;
                                color: #999999;
                            }
                        }

                        .publishtitle {
                            line-height: 20px;
                            text-align: left;
                            width: 304px;
                            margin: 0 0 20px 10px;
                            color: #555555;
                            display: inline-block;

                            a {
                                text-decoration: none;
                                color: #555555;
                            }
                        }
                    }
                }
            }

            .bottom-center {
                float: left;
                width: 400px;
                display: inline-block;
                margin: 0 20px 0;
                padding: 0px 0px 0px 0px;

                ul {
                    height: 333px;

                    li {
                        text-align: left;
                        padding: 20px 0 20px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        border-bottom: 2px dashed #eeeeee;

                        a {
                            font-size: 14px;
                            color: #555555;
                            text-decoration: none;
                        }
                    }
                }
            }

            .bottom-right {
                float: left;
                width: 360px;
                display: inline-block;

                //padding: 0px 28px 0px;
                img {
                    width: 360px;
                    height: 320px;
                    margin: 10px 0px 0px;
                }
            }
        }
    }
    .joinOur {
        font-size:16px;width:110px;height:40px;background:#E71F10;line-height:40px;color:#fff;border-radius:5px;position:absolute;top:50%;margin-top:-20px;z-index:11;left:50%;margin-left:-55px;cursor:pointer;
    }

    .content1,
    .content1 .top {
        width: 100%;
        overflow: hidden;
        background: #071d36;
    }

    .hero-carousel,
    .hero-image {
        width: 100%;
    }

    .hero-image {
        display: block;
        height: 100%;
        object-fit: cover;
        object-position: center;
        background: #071d36;
    }

    .content-image-fallback {
        box-sizing: border-box;
        padding: 55px 90px;
        object-fit: contain;
        background: #f4f8fb;
    }

    .article-card {
        border-radius: 8px;
        box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
        overflow: hidden;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

    .article-card:hover {
        transform: translateY(-3px);
        box-shadow: 0 10px 24px rgba(0, 0, 0, 0.1);
    }

    @media (max-width: 1199.98px) {
        .content {
            width: 100% !important;
            max-width: 100% !important;
            padding: 0 10px;
            box-sizing: border-box;
        }

        .content .top {
            height: auto !important;
        }

        .content .top .top-left,
        .content .top .top-right {
            width: 100% !important;
            float: none !important;
            height: auto !important;
        }

        .content .top .top-right {
            padding-top: 10px;
        }

        .content .center {
            height: auto !important;
        }

        .content .center .center-left,
        .content .center .center-right {
            width: 100% !important;
            float: none !important;
            display: block !important;
            margin: 0 !important;
        }

        .content .center .center-left li {
            height: auto !important;
            overflow: hidden;
        }

        .content .center .center-left li .news-image {
            width: 130px !important;
            height: auto !important;
        }

        .content .center .center-left li .news-content {
            width: calc(100% - 140px) !important;
            float: right !important;
            height: auto !important;
        }

        .content .bottom {
            height: auto !important;
        }

        .content .bottom .bottom-left,
        .content .bottom .bottom-center,
        .content .bottom .bottom-right {
            width: 100% !important;
            float: none !important;
            margin: 0 !important;
        }

        .content .bottom .bottom-left ul,
        .content .bottom .bottom-center ul {
            height: auto !important;
        }

        .content .bottom .bottom-left-members-show,
        .content .bottom .bottom-left-friend-link {
            width: 100% !important;
            overflow-x: auto !important;
        }

        .content .bottom .bottom-left-members-show .member-grid {
            grid-template-columns: repeat(3, minmax(0, 1fr));
        }

        .content .bottom .bottom-left .publishtitle {
            width: 100% !important;
            margin-left: 0 !important;
        }

        .content .bottom .bottom-left .publishtitle a,
        .content .bottom .bottom-center li a {
            white-space: normal !important;
            word-break: break-word !important;
        }

        [style*="width: 1200px"],
        [style*="width:1200px"],
        [style*="width: 1180px"],
        [style*="width:1180px"],
        [style*="width: 840px"],
        [style*="width:840px"],
        [style*="width: 360px"],
        [style*="width:360px"] {
            width: 100% !important;
            max-width: 100% !important;
            box-sizing: border-box !important;
        }

        [style*="margin: 0px 130px"],
        [style*="margin: 0 130px"] {
            margin: 0 !important;
        }
    }

    @media (max-width: 767.98px) {
        .content .top .top-left .el-carousel img {
            height: 220px !important;
        }

        .content .center .center-left li .news-image {
            width: 90px !important;
        }

        .content .center .center-left li .news-content {
            width: calc(100% - 100px) !important;
        }

        .content .center .center-left li .news-content a {
            white-space: normal !important;
            padding: 4px !important;
        }

        .content .bottom .bottom-left-members-show ul li {
            float: none !important;
            display: inline-block !important;
        }

        .content .bottom .bottom-left-members-show .member-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }

        [style*="width: 170px"],
        [style*="width:170px"] {
            width: 130px !important;
        }

        .seamless-warp {
            height: auto !important;
            overflow-x: auto !important;
        }
    }
</style>
